// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2sMGc","approved":"Status_approved__12ebM","rejected":"Status_rejected__3WShW","expired":"Status_expired__3bJcO","label":"Status_label__3ZLc2"};